export const OBNP_MAPPINGS_RESET_STATE = 'OBNP_MAPPINGS_RESET_STATE';
export const OBNP_MAPPINGS_CURRENT_ITEM = 'OBNP_MAPPINGS_CURRENT_ITEM';

export const OBNP_MAPPINGS_REQUEST_LOADING = 'OBNP_MAPPINGS_REQUEST_LOADING';
export const OBNP_MAPPINGS_REQUEST_SUCCESS = 'OBNP_MAPPINGS_REQUEST_SUCCESS';
export const OBNP_MAPPINGS_REQUEST_FAILED = 'OBNP_MAPPINGS_REQUEST_FAILED';

export const OBNP_MAPPINGS_CURRENT_ACTION = 'OBNP_MAPPINGS_CURRENT_ACTION';
export const OBNP_MAPPINGS_RESET_ACTION = 'OBNP_MAPPINGS_RESET_ACTION';